import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { getWaitUntil } from '@/features/userDeactivate/selectors';

import Countdown from './component';
import styles from './styles';

const mapStateToProps = state => ({
  waitUntil: getWaitUntil(state),
});

export default compose(connect(mapStateToProps), withStyles(styles))(Countdown);
